import React from 'react';
import Trigger from './Trigger';
import EditTrigger from './EditTrigger';

const TriggersList = ({
  triggers,
  newTriggerType,
  confirmDelete,
  cancelAddNewTrigger,
  receiveNewTrigger,
  receiveEditedTrigger,
}) => {
  // Show enabled triggers first in the table
  const sortedTriggers = triggers.sort(
    (first, second) => second.enabled - first.enabled,
  );

  return (
    <div className="Triggers-table Animated Animated--fadeIn">
      {newTriggerType && (
        <EditTrigger
          trigger={{ triggerable_type: newTriggerType }}
          cancelEdit={cancelAddNewTrigger}
          receiveNewTrigger={receiveNewTrigger}
        />
      )}
      {sortedTriggers.length > 0 ? (
        sortedTriggers.map(trigger => (
          <Trigger
            key={trigger.id}
            trigger={trigger}
            confirmDelete={confirmDelete}
            receiveEditedTrigger={receiveEditedTrigger}
          />
        ))
      ) : (
        <div className="mb-24">{t('triggers.blank_slate')}</div>
      )}
    </div>
  );
};

export default TriggersList;
